const shortenPostcode = (postcode: string | undefined) => postcode?.split(' ')[0];

export default shortenPostcode;
